import { CarrierVisitDirection } from '@storage/app/api'
import { PATHS } from '@tom-ui/utils'
import { useNavigate } from 'react-router'

export const useHandlePlan = () => {
  const navigate = useNavigate()

  return (
    carrierVisitId: number,
    handlingDirection: CarrierVisitDirection,
    discriminator: string,
  ) => {
    if (!carrierVisitId || !handlingDirection) return

    navigate(
      `${PATHS.yard.planningDashboard.url}/${carrierVisitId}/${handlingDirection}/${discriminator}`,
    )
  }
}

export const useCarrierVisitDetails = () => {
  const navigate = useNavigate()

  return (carrierVisitId: number, discriminator: string) => {
    if (!carrierVisitId) return

    if (discriminator === 'VesselVisit') {
      navigate(`${PATHS.visits.vesselVisits.url}/${carrierVisitId}`)
    } else {
      navigate(`${PATHS.visits.railVisits.url}/${carrierVisitId}`)
    }
  }
}
